/**
 * Rental handover-photo API client (FE-D2, Wave-2 / E-105 Phase 3).
 *
 * Server-proxied multipart upload — a MinIO-adapternek nincs presign, így a fájl
 * a `POST /rentals/:id/handover-photos`-on megy át (FormData: file + kind). A
 * tárolás Document-backed (BE-1, ADR-092) — a FE számára ez transzparens.
 */
import type { HandoverPhotoKind, RentalHandoverPhoto } from '@kgc/api-contract';
import { api } from './client';

/** Egy handover-fotó feltöltése (kiadáskor HANDOVER, visszavételkor RETURN). */
export async function uploadHandoverPhoto(
  rentalId: string,
  file: File,
  kind: HandoverPhotoKind
): Promise<RentalHandoverPhoto> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('kind', kind);

  const response = await api.upload<{ data: RentalHandoverPhoto }>(
    `/rentals/${rentalId}/handover-photos`,
    formData
  );
  return response.data;
}

/** Egy bérlés handover-fotóinak listája, opcionális fázis-szűrővel. */
export async function listHandoverPhotos(
  rentalId: string,
  kind?: HandoverPhotoKind
): Promise<RentalHandoverPhoto[]> {
  const query = kind ? `?kind=${kind}` : '';
  const response = await api.get<{ data: RentalHandoverPhoto[] }>(
    `/rentals/${rentalId}/handover-photos${query}`
  );
  return response.data;
}

/** A fotó bináris tartalmának endpoint-path-e (auth-os blob-letöltéshez / <img>-hez). */
export function getHandoverPhotoContentUrl(rentalId: string, photoId: string): string {
  return `/rentals/${rentalId}/handover-photos/${photoId}/content`;
}
